import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext, useForm } from 'react-hook-form';
import { Form, Table, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FormFieldError from 'src/components/general/FormFieldError';
import {
    faAsterisk,
    faExclamationTriangle,
    faPlus,
    faTimes,
    faSearch,
    faBroom,
    faFilter,
    faClipboardList,
    faClipboardCheck
} from '@fortawesome/free-solid-svg-icons';
import ActionIcon from 'src/components/general/ActionIcon';
import {
    calcTotalContadoContraEntregaImportes,
    formatterPeso,
    getClearObject,
    PFLabelConstructor
} from 'src/utils/utils';
import { isNotEmptyArray } from 'src/services/validationService';
import ProvisionOrderDetailModal from 'src/components/pages/FundRequests/modal/ProvisionOrderDetailModal';
import FigurativeModal from 'src/components/pages/FundRequests/modal/FigurativeModal';
import RCPagination from 'src/components/common/RCPagination';
import { getFundRequestsToEdit } from 'src/redux/fundRequests/fundRequestsReducer';
import { clearListOrderPayData } from 'src/redux/orderPay/orderPayActions';
import { getGlobalDataSelectedPeriod } from "src/redux/globalData/globalDataReducer";
import { figurativeRegistrationCompleted, figurativeRegistrationMissing } from 'src/utils/label';

const ProvisionOrderListBox = props => {

    const dispatch = useDispatch();

    const { selectedFundRequestType, isFetching, tryMethod, clearMethod, metaData, provisionOrders } = props;

    const [budgetType, setBudgetType] = useState(undefined);
    const [viewSelectedItem, setViewSelectedItem] = useState(false);
    const [filteredSelectedItems, setFilteredSelectedItems] = useState([]);
    const fundRequestEditSelected = useSelector(state => getFundRequestsToEdit(state));
    const globalSelectedPeriod = useSelector(state => getGlobalDataSelectedPeriod(state));

    //Pagination data
    const page = metaData?.page + 1;
    const totalItemsCount = metaData?.filteredCount ? metaData?.filteredCount : '1';
    const totalItems = metaData?.filteredCount ? metaData?.filteredCount : '0';

    //Parent Form Controller
    const {
        admServiceId,
        selectedItems,
        setSelectedItems,
        itemsRelated,
        bankAccountId,
        register,
        errors,
        ordenesAsociadas,
        setOrdenesAsociadas
    } = useFormContext();

    //Parent Form Controller Validations
    const payOrderValidationObj = { required: PFLabelConstructor(selectedFundRequestType)?.required };

    //Form filters
    const { register: regItem, reset, getValues } = useForm();
    const [filtersToSend, setFiltersToSend] = useState({});

    //Modal Figurative
    const [showFigurativeModal, setShowFigurativeModal] = useState(false);
    const [activeFundRequestDetailDto, setActiveFundRequestDetailDto] = useState(null);

    const hasItemFetched = provisionOrders?.length > 0;
    const hasItemsSelected = selectedItems?.length > 0;
    const hasItemsAsociados = ordenesAsociadas?.some(i => i.selected);

    const relatedAmounts = calcTotalContadoContraEntregaImportes(itemsRelated);

    //Detail Modal
    const [activeProvisionOrder, setActiveProvisionOrder] = useState();
    const [showProvisionOrderDetailModal, setShowProvisionOrderDetailModal] = useState(false);

    const handleModalDetalleProvisionOrder = (provisionOrder) => {
        setShowProvisionOrderDetailModal(true);
        setActiveProvisionOrder(provisionOrder);
    };

    const fetchList = (params) => {
        dispatch(clearMethod());
        dispatch(tryMethod(params))
    };

    const pickedItems = selectedItems?.concat(ordenesAsociadas.filter(i => i.selected));
    const defaultParams = {
        page: 0,
        size: 10,
        state: 'BORRADOR',
        administrativeServiceId: fundRequestEditSelected ? fundRequestEditSelected?.administrativeServiceId : admServiceId,
        acquisitionType: props.acquisitionType,
        year: globalSelectedPeriod?.year,
        bankAccountId: bankAccountId
    };

    const handleCheckCondition = (item) => {
        return !selectedItems?.some(obj => obj.provisionOrder.id === item.id);
    };

    const clearFilters = () => {
        setFiltersToSend({});
        reset();
        fetchList(defaultParams);
    };

    const handleSubmitter = (params) => {
        const newFilterObject = getClearObject(params);
        if (!isFetching) {
            fetchList(newFilterObject);
        }
    };

    const onPageChange = (pNumber) => {
        const filterParams = {
            ...defaultParams,
            number: filtersToSend?.number,
            'ad.codeOrganism': filtersToSend?.ad?.codeOrganism,
            'ad.number': filtersToSend?.ad?.number,
            'ad.year': filtersToSend?.ad?.year,
            beneficiaryName: filtersToSend?.beneficiaryName,
            beneficiaryCuit: filtersToSend?.beneficiaryCuit,
            page: pNumber - 1,
        };
        handleSubmitter(filterParams);
    };

    const onSubmitFormFilter = () => {
        const data = getValues();
        const filterParams = {
            ...defaultParams,
            number: data?.number,
            'ad.codeOrganism': data?.ad?.codeOrganism,
            'ad.number': data?.ad?.number,
            'ad.year': data?.ad?.year,
            beneficiaryName: data?.beneficiaryName,
            beneficiaryCuit: data?.beneficiaryCuit
        };
        setFiltersToSend(data);
        handleSubmitter(filterParams);
    };

    const addProvisionOrderToSelectionList = provisionOrder => {
        let provisionOrderCopy = JSON.parse(JSON.stringify(provisionOrder));
        setViewSelectedItem(true);
        // Convert provision order to payment order format for consistency
        let convertedOrder = {
            id: provisionOrderCopy.id,
            administrativeServiceId: provisionOrderCopy.administrativeServiceId,
            totalAmount: provisionOrderCopy.totalAmount || 0,
            number: provisionOrderCopy.number,
            year: provisionOrderCopy.year,
            destination: provisionOrderCopy.destination,
            acquisitionType: provisionOrderCopy.acquisitionType,
            legalInstrument: provisionOrderCopy.legalInstrument,
            initiator: provisionOrderCopy.initiator,
            provisionOrderRows: provisionOrderCopy.provisionOrderRows,
            administrativeDocument: {
                codeOrganism: provisionOrderCopy.administrativeDocument?.codeOrganism || '',
                number: provisionOrderCopy.administrativeDocument?.number || '',
                year: provisionOrderCopy.administrativeDocument?.year || provisionOrderCopy.year
            },
            beneficiary: provisionOrderCopy.beneficiary,
            hasFigurativeExpenditure: provisionOrderCopy.hasFigurativeExpenditure,
        };

        let fundRequestDetailDto = {
            provisionOrder: convertedOrder
        };
        setSelectedItems(prevArray => [...prevArray, fundRequestDetailDto]);
    }

    const removePayOrderFromSelectionList = provisionOrderDto => {
        if ((selectedItems?.length == 1) && (ordenesAsociadas.filter(item => item?.selected == true)?.length == 0)) setBudgetType('');
        setSelectedItems(selectedItems.filter(item => item.provisionOrder.id !== provisionOrderDto.id));
        delete provisionOrderDto?.fundRequestFigurativeExpenditures;
    };

    const updateAsociadas = (ordenAsociada, isChecked) => {
        if (!isChecked && selectedItems?.length == 0) {
            ordenesAsociadas?.filter(item => item?.selected == true)?.length == 1 && setBudgetType('');
        } else if (selectedItems?.length == 0) {
            const detail = ordenAsociada?.provisionOrder?.details?.[0];
            setBudgetType(detail?.presupuestoResponse?.budgetType);
        }
        setOrdenesAsociadas(ordenesAsociadas.map(item => {
            if (item.id == ordenAsociada.id) {
                item.selected = isChecked;
            }
            return item;
        }));
    };

    const submitFilterByEnter = (e) => {
        e.preventDefault();
        onSubmitFormFilter();
    };

    const openModalFigurative = fundRequestDetailDto => {
        setActiveFundRequestDetailDto(fundRequestDetailDto);
        setShowFigurativeModal(true);
    };

     const figurativeCalculationTotalAmount = (data) => {
        const figurativeData = data?.filter((item) => item?.figurativeExpenditures?.length);
        if (isNotEmptyArray(figurativeData)) {
            return figurativeData?.length > 1 ?
                figurativeData?.map((item) => item?.figurativeExpenditures?.map(item => item?.amount)?.reduce((a, b) => a + b))?.reduce((a, b) => a + b) :
                figurativeData?.[0]?.figurativeExpenditures?.map(item => item?.amount)?.reduce((a, b) => a + b)
        }
        return 0;
    };

    // Get amount for provision orders
    const getProvisionAmount = (item) => {
        return item.totalAmount || 0;
    };

    // Get beneficiary info for provision orders
    const getBeneficiaryName = (item) => {
        return item?.beneficiary?.persona?.companyName || 'Sin beneficiario';
    };

    // Get CUIT for provision orders
    const getBeneficiaryCuit = (item) => {
        return item?.beneficiary?.persona?.cuit || '';
    };

    // Get reception date
    const getReceptionDate = (item) => {
        return item?.receptionActs?.[0]?.receiptDate || '';
    };

    useEffect(() => {
        bankAccountId && clearFilters();
        return () => {
            setSelectedItems([]);
            dispatch(clearListOrderPayData());
        }
    }, [bankAccountId]);

    useEffect(() => {
        if (fundRequestEditSelected) {
            setOrdenesAsociadas(ordenesAsociadas.map(i => {
                i.selected = true;
                return i;
            }));
        }
    }, []);

    useEffect(() => {
        setFilteredSelectedItems(
            selectedItems.filter(selItems => !ordenesAsociadas.some(ordAs => ordAs.id === selItems.id))
        )
    }, [ordenesAsociadas, selectedItems]);

    useEffect(() => {
        if (fundRequestEditSelected?.details) {
            setOrdenesAsociadas(fundRequestEditSelected?.details ? fundRequestEditSelected?.details?.map(item => {
                item.selected = true;
                if (item.provisionOrder) item.asociated = true
                return item;
            }) : []);
        }
    }, [fundRequestEditSelected]);

    useEffect(() => {
        if (budgetType == undefined) {
            const detail = fundRequestEditSelected?.details?.[0]?.provisionOrder?.details?.[0];
            setBudgetType(detail?.presupuestoResponse?.budgetType)
        }
    }, [provisionOrders])

    return <>
        <h6 className='text-black-color my-3'>Órdenes de Provisión disponibles:</h6>

        {admServiceId &&
            <div>
                <Table striped bordered hover size='sm'>
                    <thead>
                        <tr className='secondary'>
                            <th className='text-center align-middle text-white' width='12%'>Número expediente</th>
                            <th className='text-center align-middle text-white' width="12%">N° Orden Provisión</th>
                            <th className='text-center align-middle text-white' width="20%">Beneficiario</th>
                            <th className='text-center align-middle text-white' width="8%">CUIT</th>
                            <th className='text-center align-middle text-white' width="35%">Descripción</th>
                            <th className='text-center align-middle text-white' width="10%">Importe</th>
                            <th className='text-center align-middle text-white' width="10%">Fecha Recep.</th>
                            <th className='text-center align-middle text-white th-minwidth'>Acciones</th>
                        </tr>
                        <tr>
                            <th>
                                <div className="input-group">
                                    <Form.Control name="ad.codeOrganism" className='text-center' placeholder="Organismo" ref={regItem} onKeyDown={(e) => e.key === 'Enter' && submitFilterByEnter(e)} />
                                    <Form.Control name="ad.number" className='text-center' placeholder="N°" ref={regItem} onKeyDown={(e) => e.key === 'Enter' && submitFilterByEnter(e)} />
                                    <Form.Control name="ad.year" className='text-center' placeholder="Año" ref={regItem} onKeyDown={(e) => e.key === 'Enter' && submitFilterByEnter(e)} />
                                </div>
                            </th>
                            <th>
                                <Form.Control onKeyDown={(e) => e.key === 'Enter' && submitFilterByEnter(e)}
                                    placeholder="" className='text-center' type='text'
                                    name="number" ref={regItem} />
                            </th>
                            <th>
                                <Form.Control onKeyDown={(e) => e.key === 'Enter' && submitFilterByEnter(e)}
                                    placeholder="" className='text-center' type='text'
                                    name="beneficiaryName" ref={regItem} />
                            </th>
                            <th>
                                <Form.Control onKeyDown={(e) => e.key === 'Enter' && submitFilterByEnter(e)}
                                    className='text-center' type='text' name='beneficiaryCuit'
                                    placeholder='' ref={regItem} />
                            </th>
                            <th className='text-center align-middle'></th>
                            <th className='text-center align-middle'></th>
                            <th className='text-center align-middle'></th>
                            <th className='text-center align-middle'>
                                <div className='d-flex justify-content-around'>
                                    <ActionIcon
                                        size="lg"
                                        id="search-button"
                                        className="btn-primary search-button text-white-color"
                                        toolTipText="Filtrar"
                                        icon={faFilter}
                                        onClick={onSubmitFormFilter}
                                    />
                                    <ActionIcon
                                        size="lg"
                                        id="clean-filter"
                                        className="btn-primary clean-filter text-white-color"
                                        toolTipText="Limpiar filtros"
                                        icon={faBroom}
                                        onClick={() => clearFilters()}
                                    />
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody className='text-black-color'>
                        {
                            hasItemFetched ?
                                <>
                                    {provisionOrders?.map((item, index) => (
                                        <tr key={item?.id}>
                                            <td className='text-center align-middle'>
                                                {item?.administrativeDocument?.codeOrganism} - {item?.administrativeDocument?.number}/{item?.administrativeDocument?.year}
                                            </td>
                                            <td className='text-center align-middle'>
                                                {item?.number} - {item?.year}
                                            </td>
                                            <td className='text-left align-middle'>
                                                {getBeneficiaryName(item)}
                                            </td>
                                            <td className='text-center align-middle'>
                                                {getBeneficiaryCuit(item)}
                                            </td>
                                            <td className='text-left align-middle'>
                                                <div title={item?.destination}>
                                                    {item?.destination.substring(0, 80)}
                                                    {item?.destination > 80 ? '...' : ''}
                                                </div>
                                            </td>
                                            <td className='text-right align-middle'>
                                                {formatterPeso.format(getProvisionAmount(item))}
                                            </td>
                                            <td className='text-center align-middle'>
                                                {getReceptionDate(item) ? new Date(getReceptionDate(item)).toLocaleDateString('es-AR') : ''}
                                            </td>
                                            <td className='text-center align-middle px-2 m-0 table-responsive btn-group'>
                                                <ActionIcon size='lg'
                                                    id={'details-provision' + index}
                                                    toolTipText='Detalle de la orden de provisión'
                                                    icon={faSearch}
                                                    onClick={() => handleModalDetalleProvisionOrder(item)}
                                                />
                                                {
                                                    handleCheckCondition(item) ?
                                                        <ActionIcon
                                                            className='ml-2'
                                                            size='lg'
                                                            id={'add-provision' + index}
                                                            toolTipText='Seleccionar orden de provisión'
                                                            icon={faPlus}
                                                            onClick={() => addProvisionOrderToSelectionList(item)}
                                                        />
                                                        :
                                                        <ActionIcon
                                                            className='text-danger ml-2'
                                                            size='lg'
                                                            id={'remove-provision' + index}
                                                            toolTipText='Quitar de la selección'
                                                            icon={faTimes}
                                                            onClick={() => removePayOrderFromSelectionList(item)}
                                                        />
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                </>
                                :
                                <tr>
                                    <td colSpan='8' className='text-center'>
                                        {
                                            !hasItemFetched &&
                                            <Alert className='mb-0' variant='info' show={!isFetching}>
                                                <FontAwesomeIcon icon={faExclamationTriangle}
                                                    className='text-black-color mr-3' />
                                                No hay registros
                                            </Alert>
                                        }
                                    </td>
                                </tr>
                        }
                    </tbody>
                </Table>
                <RCPagination
                    activePage={page}
                    itemsCountPerPage={defaultParams.size}
                    totalItemsCount={totalItemsCount}
                    pageRangeDisplayed={7}
                    thePage={page}
                    totalItems={totalItems}
                    innerClass="justify-content-center"
                    onChange={onPageChange}
                />
            </div>
        }

        {showFigurativeModal &&
            <FigurativeModal
                setShowFigurativeModal={setShowFigurativeModal}
                showFigurativeModal={showFigurativeModal}
                setSelectedItems={setSelectedItems}
                selectedItems={selectedItems}
                setActiveFundRequestDetailDto={setActiveFundRequestDetailDto}
                activeFundRequestDetailDto={activeFundRequestDetailDto}
                setOrdenesAsociadas={setOrdenesAsociadas}
                ordenesAsociadas={ordenesAsociadas}
                isProvisionOrder={true}
                bankAccountId={bankAccountId}
            />
        }

        <ProvisionOrderDetailModal
            showProvisionOrderDetailModal={showProvisionOrderDetailModal}
            setShowProvisionOrderDetailModal={setShowProvisionOrderDetailModal}
            activeProvisionOrder={activeProvisionOrder}
            selectedFundRequestType={selectedFundRequestType}
        />

        {(hasItemsSelected && viewSelectedItem) &&
            <>
                <Form.Group className='d-inline'>
                    <Form.Label className='text-black-color pr-0 d-flex'>
                        <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger' />
                        <h6>Órdenes de Provisión seleccionadas:</h6>
                    </Form.Label>
                </Form.Group>
                <Table striped bordered hover size='sm'>
                    <thead>
                        <tr>
                            <th className='text-center text-white' width="15%">Expediente</th>
                            <th className='text-center text-white' width="15%">N° O. Provisión</th>
                            <th className='text-center text-white' width="20%">Beneficiario</th>
                            <th className='text-center text-white' width="35%">Descripción</th>
                            <th className='text-center text-white' width="10%">Importe</th>
                            <th className='text-center text-white' width="10%">Figurativa</th>
                            <th className='text-center align-middle text-white th-minwidth'>Acciones</th>
                        </tr>
                    </thead>
                    <tbody className='text-black-color'>
                        {filteredSelectedItems
                            .map((item, i) => {
                                return (<tr key={i}>
                                    <td className='text-center align-middle'>
                                        {item?.provisionOrder?.administrativeDocument?.codeOrganism} - {item?.provisionOrder?.administrativeDocument?.number}/{item?.provisionOrder?.administrativeDocument?.year}
                                    </td>
                                    <td className='text-center align-middle'>
                                        {item?.provisionOrder?.number} - {item?.provisionOrder?.year}
                                    </td>
                                    <td className='text-left align-middle'>
                                        {item?.provisionOrder?.beneficiary?.persona?.companyName || 'Sin beneficiario'}
                                    </td>
                                    <td className='text-left align-middle'>
                                        {item?.provisionOrder?.description?.substring(0, 80)}
                                    </td>
                                    <td className='text-right align-middle'>
                                        {formatterPeso.format(item?.provisionOrder?.totalAmount || 0)}
                                    </td>
                                    <td className='text-right align-middle'>
                                        {formatterPeso.format(figurativeCalculationTotalAmount([item]))}
                                    </td>
                                    <td className='text-center align-middle px-2 m-0 table-responsive btn-group'>
                                        {
                                            item?.provisionOrder?.hasFigurativeExpenditure &&
                                            <ActionIcon
                                                size='lg'
                                                id={'figurative-orden' + i}
                                                className='text-success'
                                                toolTipText={(item?.figurativeExpenditures) ? figurativeRegistrationCompleted : figurativeRegistrationMissing}
                                                icon={(item?.figurativeExpenditures) ? faClipboardCheck : faClipboardList}
                                                onClick={() => openModalFigurative(item)}
                                            />
                                        }
                                        <ActionIcon size='lg' id={'details-orden' + i}
                                            toolTipText='Detalle de la orden de provisión' icon={faSearch}
                                            onClick={() => handleModalDetalleProvisionOrder(item?.provisionOrder)} />
                                        <ActionIcon size='lg' id={'remove-order' + i}
                                            toolTipText='Quitar de la selección' icon={faTimes}
                                            className='text-danger'
                                            onClick={() => removePayOrderFromSelectionList(item.provisionOrder)} />
                                    </td>
                                </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
            </>
        }

        {!!ordenesAsociadas?.length &&
            <>
                <Form.Group className='d-inline'>
                    <Form.Label className='text-black-color pr-0 d-flex'>
                        <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger' />
                        <h6>Órdenes de Provisión asociadas:</h6>
                    </Form.Label>
                </Form.Group>
                <Table striped bordered hover size='sm'>
                    <thead>
                        <tr>
                            <th className='text-center text-white' width="15%">Expediente</th>
                            <th className='text-center text-white' width="10%">N° Orden Provisión</th>
                            <th className='text-center text-white' width="20%">Beneficiario</th>
                            <th className='text-center text-white' width="30%">Descripción</th>
                            <th className='text-center text-white' width="10%">Importe</th>
                            <th className='text-center text-white' width="10%">Figurativa</th>
                            <th className='text-center text-white' width="5%"></th>
                        </tr>
                    </thead>
                    <tbody className='text-black-color'>
                        {
                            ordenesAsociadas.map((item, i) => (
                                <tr key={item.id}>
                                    <td className='text-center align-middle'>
                                        {item?.provisionOrder?.administrativeDocument?.codeOrganism} - {item?.provisionOrder?.administrativeDocument?.number}/{item?.provisionOrder?.administrativeDocument?.year}
                                    </td>
                                    <td className='text-center align-middle'>
                                        {item?.provisionOrder?.number} - {item?.provisionOrder?.year}
                                    </td>
                                    <td className='text-left align-middle'>
                                        {item?.provisionOrder?.beneficiary?.persona?.companyName || 'Sin beneficiario'}
                                    </td>
                                    <td className='text-left align-middle'>
                                        {item?.provisionOrder?.description || item?.provisionOrder?.destination}
                                    </td>
                                    <td className='text-right align-middle'>
                                        {formatterPeso.format(item?.provisionOrder?.amount || item?.provisionOrder?.totalAmount || 0)}
                                    </td>
                                    <td className='text-right align-middle'>
                                       {formatterPeso.format(figurativeCalculationTotalAmount([item]))}
                                    </td>
                                    <td className='text-center align-middle px-2 m-0 table-responsive btn-group'>
                                        {(item?.provisionOrder?.hasFigurativeExpenditure  || isNotEmptyArray(item?.figurativeExpenditures)) &&
                                            <ActionIcon
                                                id={'figurative-orden' + i}
                                                className='text-success mr-1'
                                                toolTipText={(item?.figurativeExpenditures) ? figurativeRegistrationCompleted : figurativeRegistrationMissing}
                                                icon={(item?.figurativeExpenditures) ? faClipboardCheck : faClipboardList}
                                                onClick={() => openModalFigurative(item)}
                                                disabled={!item?.selected}
                                            />
                                        }
                                        <Form.Check
                                            className={`mx-2 mt-1 ext-black-color item${item?.provisionOrder?.id}`}
                                            checked={item?.selected}
                                            onChange={event => updateAsociadas(item, event.target.checked)}
                                        />
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </Table>
            </>
        }

        <Form.Control value={hasItemsSelected || hasItemsAsociados ? 'true' : ''} type='hidden' name='hasItemsSelected'
            ref={register(payOrderValidationObj)} />
        {!(hasItemsSelected || hasItemsAsociados) &&
            <FormFieldError errors={errors?.hasItemsSelected} />
        }

        <h6 className="text-right">Importe Pedido de
            Fondos {formatterPeso.format(calcTotalContadoContraEntregaImportes(pickedItems, relatedAmounts))}</h6>
    </>

};

export default ProvisionOrderListBox;